import styled from '@emotion/styled'
import type { FC } from 'react'

import { AppearanceProvider } from '@segment/matcha/foundations/AppearanceContext'

import NavigationBrand from '@segment/templates/NavigationBrand'

import LayoutBase from '@segment/next-shared/layout'

import Footer from './components/Footer'
import RequestDemo from './components/RequestDemo'
import Reviewers from './components/Reviewers'
import CustomersRankSegment from './components/CustomersRankSegment'
import ComprehensiveG2 from './components/ComprehensiveG2'
import Badges from './components/Badges/Badges'
import Testimonial from './components/Testimonial'
import Hero from './components/Hero'

const G2GridReportCdpView: FC = () => {
  return (
    <AppearanceProvider appearance="twilioLight">
      <LayoutBase
        pageTitle="G2: Spring 2023 Grid Report"
        pageDescription="Based on 500+ reviews, Segment is a top ranked CDP with 96% of users rating 4 or 5 stars, 91% customer recommendation rating, 90% ease of use score, and the largest market presence amongst all vendors."
      >
        <NavigationBrand />
        <Hero />
        <Main>
          <Testimonial />
          <Badges />
          <ComprehensiveG2 />
          <CustomersRankSegment />
          <Reviewers />
          <RequestDemo />
        </Main>
        <Footer />
      </LayoutBase>
    </AppearanceProvider>
  )
}

const Main = styled.main`
  background: ${({ theme }) => theme.palette.neutrals.white[100]};
`

export default G2GridReportCdpView
